import { render } from "./CodexView.vue?vue&type=template&id=721fbf54&scoped=true"
import script from "./CodexView.vue?vue&type=script&lang=js"
export * from "./CodexView.vue?vue&type=script&lang=js"

import "./CodexView.vue?vue&type=style&index=0&id=721fbf54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721fbf54"]])

export default __exports__